import docOutAchievementIndex from "../views/doc-out/achievement/doc-out-achievement-index.vue";
import VbDuThaoNewIndex from "../views/doc-out/NewIndex.vue";
import VbChoBanHanhIndex from "../views/doc-out/VbChoBanHanhIndex.vue";
import VbDaBanHanhIndex from "../views/doc-out/VbDaBanHanhIndex.vue";
import VbDaPhatHanhNewIndex from "../views/doc-out/VbDaPhatHanhNewIndex.vue";
import docOutDetail from "../views/doc-out/Detail.vue";
import vbDaVaoSoLDDetail from "../views/doc-out/vbDaVaoSoLDDetail.vue";
import tdhvpDocOutDetail from "../views/thdvp/doc-out/tdhvp-doc-out-detail";
import tdhvpDocOutIndex from "../views/thdvp/doc-out/tdhvp-doc-out-index";
import tdhvpDocOutVtIndex from "../views/thdvp/doc-out/tdhvp-doc-out-vt-index";
import docOutLanhDaoEdit from "../views/doc-out/docOutLanhDaoEdit";
import lockedRoleDocOutIndex from "../views/doc-out/locked-role/lockedRoleDocOutIndex.vue";
import lockedRoleDocOutCV from "../views/doc-out/locked-role/lockedRoleDocOutCV.vue";
import lockedRoleDocOutVT from "../views/doc-out/locked-role/lockedRoleDocOutVT.vue";
import DetailLockedRoleDocOut from "../views/doc-out/locked-role/Detail.vue";
import improperAccessCheckingService from "../services/improperAccessCheckingService";
import Constants from "../constants";


export default [
  // văn bản dự thảo (new)
  {
    path: "/app/:userDeptRoleId/vbDuThaoNew",
    name: "vbDuThaoNew",
    component: VbDuThaoNewIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI_DUTHAO)
    }
  },

  {
    path: "/app/:userDeptRoleId/vbDuThaoNew/edit/:id",
    name: "vbDuThaoNewEdit",
    components: {
      default: () => import("../views/doc-out/NewIndex.vue"),
      detail: () => import("../views/doc-out/VbDuThaoEdit")
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI_DUTHAO)
    }
  },

  {
    path: "/app/:userDeptRoleId/vbDuThaoLanhDaoEdit/:id",
    name: "vbDuThaoLanhDaoEdit",
    components: {
      default: () => import("../views/doc-out/NewIndex.vue"),
      detail: docOutLanhDaoEdit
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI_DUTHAO)
    }
  },

  {
    path: "/app/:userDeptRoleId/vbChoBanHanh/detail/:id/hieuChinh",
    name: "vbChoBanHanhHieuChinh",
    components: {
      default: VbChoBanHanhIndex,
      detail: docOutDetail,
      detail2: () => import("../views/doc-out/HieuChinh")
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI_CHOBANHANH)
    }
  },

  {
    path: "/app/:userDeptRoleId/vbDuThaoNew/detail/:id",
    name: "vbDuThaoNewDetail",
    components: {
      default: () => import("../views/doc-out/NewIndex.vue"),
      detail: docOutDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI_DUTHAO)
    }
  },
  // ======================================== //

  // văn bản đã phát hành (new)
  {
    path: "/app/:userDeptRoleId/vbDaPhatHanhNew",
    name: "vbDaPhatHanhNew",
    component: VbDaPhatHanhNewIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI_DAPHATHANH)
    }
  },

  {
    path: "/app/:userDeptRoleId/vbDaPhatHanhNew/detail/:id",
    name: "vbDaPhatHanhNewDetail",
    components: {
      default: VbDaPhatHanhNewIndex,
      detail: docOutDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI_DAPHATHANH)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbChoBanHanh",
    name: "vbChoBanHanh",
    component: VbChoBanHanhIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI_CHOBANHANH)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbChoBanHanh/detail/:id",
    name: "vbChoBanHanhDetail",
    components: {
      default: VbChoBanHanhIndex,
      detail: docOutDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI_CHOBANHANH)
    }
  },
  // //===================Da ban hanh================
  {
    path: "/app/:userDeptRoleId/vbDaBanHanh",
    name: "vbDaBanHanh",
    component: VbDaBanHanhIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI_DABANHANH)
    }
  },
  {
    path: "/app/:userDeptRoleId/vbDaBanHanh/detail/:id",
    name: "vbDaBanHanhDetail",
    components: {
      default: VbDaBanHanhIndex,
      detail: docOutDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI_DABANHANH)
    }
  },
  // //============Quangnd start============
  {
    path: "/app/:userDeptRoleId/vbDiDaVaoSo/",
    name: "vbDiDaVaoSo",
    component: () => import("../views/doc-out/vbDiDaVaoSoIndex.vue"),
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.QL_SOVANBAN_SODI)
    }
  },

  {
    path: "/app/:userDeptRoleId/vbDiDaVaoSoLD/",
    name: "vbDiDaVaoSoLD",
    component: () => import("../views/doc-out/vbDiDaVaoSoLDIndex.vue"),
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.DANHSACH_VANBAN_DI)
    }
  },

  {
    path: "/app/:userDeptRoleId/vbDiDaVaoSo/detail/:id",
    name: "vbDiDaVaoSoDetail",
    components: {
      default: () => import("../views/doc-out/vbDiDaVaoSoIndex.vue"),
      detail: docOutDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.QL_SOVANBAN_SODI)
    }
  },

  {
    path: "/app/:userDeptRoleId/vbDiDaVaoSoLD/detail/:id",
    name: "vbDiDaVaoSoLDDetail",
    components: {
      default: () => import("../views/doc-out/vbDiDaVaoSoLDIndex.vue"),
      detail: vbDaVaoSoLDDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.DANHSACH_VANBAN_DI)
    }
  },
  // //============Quangnd end============

  //quản lý văn bản dự thảo đã xóa
  {
    path: "/app/:userDeptRoleId/deletedDocOutIndex/",
    name: "deletedDocOutIndex",
    component: docOutAchievementIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI_DUTHAO)
    }
  },

  {
    path: "/app/:userDeptRoleId/deletedDocOutIndex/detail/:id",
    name: "deletedDocOutDetail",
    components: {
      default: docOutAchievementIndex,
      detail: docOutDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI_DUTHAO)
    }
  },
  //quản lý văn bản dự thảo đã xóa:end

  //chức năng tra cứu văn bản cũ từ hệ thống tdhvp
  {
    path: "/app/:userDeptRoleId/tdhvp-doc-out",
    name: "tdhvpDocOutIndex",
    component: tdhvpDocOutIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI)
    }
  },
  {
    path: "/app/:userDeptRoleId/tdhvp-doc-out/detail/:id",
    name: "tdhvpDocOutDetail",
    components: {
      default: tdhvpDocOutIndex,
      detail: tdhvpDocOutDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI)
    }
    // //============Quangnd end============
  },
  {
    path: "/app/:userDeptRoleId/tdhvp-doc-out-vt",
    name: "tdhvpDocOutVtIndex",
    component: tdhvpDocOutVtIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI)
    }
  },
  {
    path: "/app/:userDeptRoleId/tdhvp-doc-out-vt/detail/:id",
    name: "tdhvpDocOutVtDetail",
    components: {
      default: tdhvpDocOutVtIndex,
      detail: tdhvpDocOutDetail
    },
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.VB_DI)
    }
  },
  //chức năng tra cứu văn bản cũ từ hệ thống tdhvp:end;
  //locked Role's Documents
  {
    path: "/app/:userDeptRoleId/lockedRoleDocOutIndex",
    name: "lockedRoleDocOutIndex",
    component: lockedRoleDocOutIndex
  },
  {
    path: "/app/:userDeptRoleId/lockedRoleDocOutCV",
    name: "lockedRoleDocOutCV",
    component: lockedRoleDocOutCV
  },
  {
    path: "/app/:userDeptRoleId/lockedRoleDocOutVT",
    name: "lockedRoleDocOutVT",
    component: lockedRoleDocOutVT
  },
  {
    path: "/app/:userDeptRoleId/lockedRoleDocOutCV/detail/:id",
    name: "DetailLockedRoleDocOut",
    components: {
      default: lockedRoleDocOutCV,
      detail: DetailLockedRoleDocOut
    }
  },
  {
    path: "/app/:userDeptRoleId/lockedRoleDocOutVT/detail/:id",
    name: "DetailLockedRoleDocOutVT",
    components: {
      default: lockedRoleDocOutVT,
      detail: DetailLockedRoleDocOut
    }
  }

];



// WEBPACK FOOTER //
// ./src/router/document-out.js